import React from 'react';
import { Divider, Grid, ListItem } from '@mui/material';
import CreditSafeComp from 'components/CreditSafeComp';
import { RowNameText } from './RowNameText';
import { CreditApplication, VendorOpportunity, VendorProfile } from '@trnsact/trnsact-shared-types';
import { ApolloQueryResult } from '@apollo/client';

interface Props {
  vp: VendorProfile;
  vo: VendorOpportunity;
  creditApplication: CreditApplication;
  userDocs: any;
  isIndividualCreditApp: boolean;
  isCreditReportsHiddenForUserRole: boolean;
  userDocsRefetch: () => Promise<ApolloQueryResult<void>>;
  refetchCreditApp: () => Promise<ApolloQueryResult<void>>;
  setDoneRefetchingDocuments: any;
  disableGutters?: boolean;
}

export const PullCreditReportRow = ({
  vp,
  vo,
  creditApplication,
  userDocs,
  isIndividualCreditApp,
  isCreditReportsHiddenForUserRole,
  userDocsRefetch,
  refetchCreditApp,
  setDoneRefetchingDocuments,
  disableGutters = false,
}: Props) => {
  const vpBusinessCreditReportPullInDealerPortal = vp?.settingBusinessCreditReportPullInDealerPortal as unknown as any;
  const isCommercialCreditReportPullEnabled =
    vpBusinessCreditReportPullInDealerPortal === 'PAYNET' ||
    vpBusinessCreditReportPullInDealerPortal === 'CREDITSAFE_FULL_REPORT' ||
    vpBusinessCreditReportPullInDealerPortal === 'DUN_AND_BRADSTREET';

  let commercialCreditReportLabel = '';
  let commercialCreditReportPullButtonLabel = '';

  switch (vpBusinessCreditReportPullInDealerPortal) {
    case 'PAYNET':
      commercialCreditReportLabel = 'Paynet Report';
      commercialCreditReportPullButtonLabel = 'Pull Paynet';
      break;
    case 'CREDITSAFE_FULL_REPORT':
      commercialCreditReportLabel = 'CreditSafe Report';
      commercialCreditReportPullButtonLabel = 'Pull CreditSafe';
      break;
    case 'DUN_AND_BRADSTREET':
      commercialCreditReportLabel = 'Dun & Bradstreet Report';
      commercialCreditReportPullButtonLabel = 'Pull Dun & Bradstreet';
      break;
    default:
      commercialCreditReportLabel = 'Credit Report';
      commercialCreditReportPullButtonLabel = 'Pull Credit Report';
  }

  // PayNet can be pulled for both individual and commercial credit apps
  if (
    (isIndividualCreditApp &&
      vpBusinessCreditReportPullInDealerPortal !== 'PAYNET' &&
      vpBusinessCreditReportPullInDealerPortal !== 'DUN_AND_BRADSTREET') ||
    !isCommercialCreditReportPullEnabled ||
    isCreditReportsHiddenForUserRole
  ) {
    return null;
  }

  return (
    <>
      <ListItem disableGutters={disableGutters}>
        <Grid container>
          <Grid item xs={6}>
            <RowNameText text={commercialCreditReportLabel} />
          </Grid>
          <Grid item xs={6}>
            <CreditSafeComp
              vo={vo}
              creditApp={creditApplication}
              userDocs={userDocs}
              openCreditPullErrorSnackBar={() => {
                alert('Credit Pull Error');
              }}
              setCreditPullErrorSnackBarText={() => {
                console.log('Credit Pull Error');
              }}
              userDocsRefetch={userDocsRefetch}
              refetchCreditApp={refetchCreditApp}
              CbrSoftPullTooltip={<div>Contact Support</div>}
              setDoneRefetchingDocuments={setDoneRefetchingDocuments}
              vpBusinessCreditReportPullInDealerPortal={vpBusinessCreditReportPullInDealerPortal}
              commercialCreditReportPullButtonLabel={commercialCreditReportPullButtonLabel}
              isIndividualCreditApp={isIndividualCreditApp}
            />
          </Grid>
        </Grid>
      </ListItem>
      <Divider />
    </>
  );
};
